export default {
  labels: {
    page: 'Pagina {{current}} din {{total}}',
    no_file_specified: 'Nu a fost specificat niciun fișier',
  },
  buttons: {
    previous: 'Anterior',
    next: 'Următor',
  },
};
